import React from 'react';
import './MemberAvailabilityCalendarSkeleton.css';

/**
 * Skeleton loader for member availability calendar
 */
const MemberAvailabilityCalendarSkeleton = () => {
  const DAYS = 5;
  const HOURS_PER_DAY = 12;
  const TOTAL_SLOTS = DAYS * HOURS_PER_DAY;

  return (
    <div className="mac-skeleton-container">
      <table className="mac-skeleton-table">
        <thead>
          <tr>
            <th className="mac-skeleton-members-col" rowSpan="2">
              <div className="mac-skeleton-header" />
            </th>
            {[...Array(DAYS)].map((_, dayIndex) => (
              <th key={dayIndex} colSpan={HOURS_PER_DAY}>
                <div className="mac-skeleton-day-header" />
              </th>
            ))}
          </tr>
          <tr>
            {[...Array(TOTAL_SLOTS)].map((_, slotIndex) => (
              <th key={slotIndex} className="mac-skeleton-time-slot">
                <div className="mac-skeleton-time" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(3)].map((_, memberIndex) => (
            <tr key={memberIndex}>
              <td className="mac-skeleton-members-col">
                <div className="mac-skeleton-member-name" />
              </td>
              {[...Array(TOTAL_SLOTS)].map((_, slotIndex) => (
                <td key={slotIndex} className="mac-skeleton-slot">
                  <div className="mac-skeleton-content" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MemberAvailabilityCalendarSkeleton;
